import isEmpty from "../validation/is-empty";
import { IMAGE_BASE_URL } from "./utility";

export const THANK_YOU_CONFIRMATION_DELAY_MS = 3000;
export const THANK_YOU_REDIRECT_DELAY_MS = 2000;

/**
 * Ensure redirect URLs include a protocol.
 * @param {string} url
 * @returns {string|null}
 */
export const normalizeRedirectUrl = (url) => {
  if (!url || typeof url !== "string") {
    return null;
  }

  const trimmed = url.trim();
  if (isEmpty(trimmed)) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

/**
 * Resolve the post-booking thank-you redirect URL for an event.
 * Redirect applies when the event uses an external confirmation page.
 * @param {object} event
 * @param {object} company
 * @returns {string|null}
 */
export const getBookingThankYouRedirectUrl = (event, company) => {
  if (!event || event.confirmation_page !== "external") {
    return null;
  }

  const url = event.confirmation_page_url || company?.thank_u_page_url;
  return normalizeRedirectUrl(url);
};

/** Staff-assigned events only (type 2). My-event bookings must not send staff_id. */
export const shouldIncludeStaffIdInBooking = (event, staffId) => {
  if (isEmpty(staffId) || isEmpty(event)) {
    return false;
  }

  return String(event.staff_assignment_type) === "2";
};

export const buildStaffProfileImageSrc = (profileImagePath) => {
  if (!profileImagePath) {
    return "";
  }

  if (/^(blob:|data:|https?:)/i.test(profileImagePath)) {
    return profileImagePath;
  }

  const path = profileImagePath.replace(/^\//, "");
  return `${IMAGE_BASE_URL}${path}`;
};

export const getStaffDisplayInitials = (firstName = "", lastName = "") => {
  const parts = [firstName, lastName].filter(Boolean);
  if (parts.length === 0) {
    return "?";
  }

  return parts
    .map((part) => part.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2);
};
